jQuery(document).ready(function ($) {

    jQuery('select').selectric({
        openOnFocus: false,
        disableOnMobile: false,
        nativeOnMobile: false
    });

    $(document).ajaxComplete(function () {
        $('select').selectric('refresh');
    });

    $(document).on('gform_page_loaded', function (event, form_id, current_page) {
        $('select').selectric('refresh');
    });

    jQuery(".validation_message").attr("role", "alert");
    jQuery(document).on('gform_page_loaded', function (event, form_id, current_page) {
        jQuery(".validation_message").attr("role", "alert");
    });

    jQuery(".left_sidebar_menu > .menu-item > .sub-menu > li > a").on("click", function () {
        $(this).closest(".left_sidebar_menu").find(".menu-item.active").removeClass("active");
        $(this).parent().addClass('active');

    });

    // if (jQuery(window).width() > 1199) {
    //     jQuery(".left_sidebar .left_sidebar_menu .menu-item.menu-item-has-children .sub-menu").css('display', 'block');
    //     jQuery(".left_sidebar .left_sidebar_menu .menu-item.menu-item-has-children").addClass('open');
    //     jQuery(".left_sidebar .left_sidebar_menu .menu-item.menu-item-has-children a.tabbing_link").addClass('active');
    // } else {
    //     jQuery(".left_sidebar .left_sidebar_menu .menu-item.menu-item-has-children .sub-menu").css('display', 'none');
    //     jQuery(".left_sidebar .left_sidebar_menu .menu-item.menu-item-has-children").removeClass('open');
    //     jQuery(".left_sidebar .left_sidebar_menu .menu-item.menu-item-has-children a.tabbing_link").removeClass('active');
    // };

    jQuery(".left_sidebar_menu > .menu-item > a").on("click", function (e) {
        e.preventDefault();
        e.stopPropagation();
        e.stopImmediatePropagation();
        $(this).parent().siblings().find('.sub-menu li').removeClass("active");
        $(this).parent().siblings().find('>a').removeClass("active");
        $(this).parent().siblings().find('>a').parent().find('> .sub-menu').slideUp().parent().removeClass('open');
        $(this).toggleClass('active').parent().find('> .sub-menu').slideToggle().parent().toggleClass('open');
        if ($(".content_with_sidebar").length > 0) {
            $("body, html").animate({
                scrollTop: $(".content_with_sidebar").offset().top - 100
            }, 1000);
        }
    });

    $(window).scroll(function () {
        var sticky = $('.site-header'),
            scroll = $(window).scrollTop();

        if (scroll >= 1) sticky.addClass('sticky');
        else sticky.removeClass('sticky');

    });

    $(".site-header-search-toggle-open").click(function () {
        $('.site-header').addClass("search_active");
        $('body').addClass("toggle_search_active");
    });

    $(".site-header-search-toggle-close").click(function () {
        $('.site-header').removeClass("search_active");
        $('body').removeClass("toggle_search_active");
    });

    $(".site-navigation-toggle-open").click(function () {
        $('.site-header').addClass("menu_active");
        $('body').addClass("toggle_menu_active");
    });

    $(".site-navigation-toggle-close").click(function () {
        $('.site-header').removeClass("menu_active");
        $('body').removeClass("toggle_menu_active");
        if ($('nav.primary-navigation li.menu-item-has-children').hasClass("open")) {
            $('nav.primary-navigation li.menu-item-has-children button.submenu-toggle').removeClass("active");
            $('nav.primary-navigation li.menu-item-has-children').removeClass("open");
            $('nav.primary-navigation li.menu-item-has-children .sub-menu').slideUp();
        }
    });

    $('nav.primary-navigation').find('li.menu-item-has-children > a').after('<button class="submenu-toggle"><svg width="11" height="7" viewBox="0 0 11 7" fill="none" xmlns="http://www.w3.org/2000/svg"><path fill-rule="evenodd" clip-rule="evenodd" d="M0.984375 1.33854L1.79638 0.5L5.98487 4.82322L10.1723 0.500052L10.9844 1.33849L5.98497 6.5L0.984375 1.33854Z" fill="#333333"/></svg></button>');
    $('body').on('click', ".site-nav .site-nav-main .primary-navigation .menu-item-has-children > a", function (e) {
        if (jQuery(window).width() < 1200) {
            e.preventDefault();
            if ($(this).parent().find(">.sub-menu").is(":hidden")) {
                $(this).parent().siblings().find('button.submenu-toggle').removeClass("active");
                $(this).parent().siblings().find('> .sub-menu').slideUp();
                $(this).parent().siblings().removeClass('open');
                $(this).addClass("active");
                $(this).parent().find('> .sub-menu').slideDown();
                $(this).parent().addClass("open");
            } else {
                $(this).removeClass("active");
                $(this).parent().find('> .sub-menu').slideUp();
                $(this).parent().removeClass("open");
            }
        }
    });

    $('.search_item_link').click(function () {
        let searchValue = $(this).attr('data-value');
        window.location.href = '/?s=' + searchValue;
    });

    jQuery(".faq").each(function (index) {
        jQuery(this).find(".faq_wrapper_list_item .faq_wrapper_list_item_inner_question").on("click", function (e) {
            e.preventDefault();
            $(this).parent().parent().siblings().find(".faq_wrapper_list_item_inner_answer").slideUp(400);
            $(this).parent().parent().siblings().removeClass("active");
            $(this).parent().parent().toggleClass("active");
            $(this).parent().find('.faq_wrapper_list_item_inner_answer').slideToggle(400);
        });
    });

    const tabs = document.querySelectorAll('.tab');
    const tabContents = document.querySelectorAll('.tab_content_item');
    const tabImgs = document.querySelectorAll('.tab_img_item');
    tabs.forEach(tab => {
        tab.addEventListener('click', function () {
            tabs.forEach(tab => tab.classList.remove('active'));
            tabContents.forEach(content => content.classList.remove('active'));
            tabImgs.forEach(content => content.classList.remove('active'));
            this.classList.add('active');
            document.getElementById(this.dataset.tabContent).classList.add('active');
            document.getElementById(this.dataset.tabImg).classList.add('active');
            if ($('.tab_content_item.active .tab_content_inner_data').hasClass("slick-initialized")) {
                jQuery(".tab_content_item.active .tab_content_inner_data").slick("refresh");
            };
        });

        // const tabs = document.querySelectorAll('.tab_data_wrapper_list .tab');
        // const tabImgs = document.querySelectorAll('.tab_data_bg_mob .tab_img_item');
        // tabs.forEach(tab => {
        //     tab.addEventListener('click', function () {
        //         tabs.forEach(tab => tab.classList.remove('active'));
        //         tabImgs.forEach(content => content.classList.remove('active'));
        //         this.classList.add('active');
        //         document.getElementById(this.dataset.tabImg).classList.add('active');
        // });
    });
    jQuery(".tab_data").each(function (index) {
        let slider = jQuery(this).find('.tab_content');
        let slide = slider.find('.tab_content_item');
        let arrowsPrev = jQuery(slide).find('.tab_content_inner_data_nav_arrows .slick-prev');
        let arrowsNext = jQuery(slide).find('.tab_content_inner_data_nav_arrows .slick-next');

        jQuery(arrowsNext).on("click", function (e) {
            e.preventDefault();
            var id = $(this).parent().parent().parent().parent().parent().attr('data-content-id');
            var active;
            jQuery(".tab").each(function (index) {
                active = $(this).attr('data-pid');
            });
            if (id == active) {
                $(active).next('.tab').click();
            }
        });
    });
    // jQuery(".tab_data").each(function (index) {

    //     $slick_prev = '<button type="button" class="slick-prev hidden"><svg width="10" height="16" viewBox="0 0 10 16" fill="none" xmlns="http://www.w3.org/2000/svg"><title>Previous Arrow</title><path d="M8.26758 2L2.01642 8.25116L8.25788 14.4926" stroke="#146EF5" stroke-width="3" stroke-linecap="round" stroke-linejoin="round"/></svg></button>';
    //     $slick_next = '<button type="button" class="slick-next"><svg width="10" height="16" viewBox="0 0 10 16" fill="none" xmlns="http://www.w3.org/2000/svg"><title>Next Arrow</title><path d="M1.75 2L8.00116 8.25116L1.7597 14.4926" stroke="#146EF5" stroke-width="3" stroke-linecap="round" stroke-linejoin="round"/></svg></button>';

    //     jQuery(".tab_content_item").each(function (index) {
    //         let slide = jQuery(this).find('.tab_content_inner_data_item');
    //         let slider = jQuery(this).find('.tab_content_inner_data');
    //         let count = jQuery(slider).parent().find('.tab_content_inner_data_nav');
    //         let dots = jQuery(slider).parent().find('.tab_content_inner_data_nav .tab_content_inner_data_nav_dots');
    //         let arrows = jQuery(slider).parent().find('.tab_content_inner_data_nav .tab_content_inner_data_nav_arrows');
    //         if (jQuery(slide).length > 1) {
    //             var currentSlide;
    //             var slidesCount;
    //             var sliderCounter = document.createElement('div');
    //             sliderCounter.classList.add('tab_content_inner_data_nav_count');

    //             var updateSliderCounter = function (slick, currentIndex) {
    //                 currentSlide = slick.slickCurrentSlide() + 1;
    //                 slidesCount = slick.slideCount.toString().padStart(2, '0');
    //                 $(sliderCounter).html(currentSlide.toString().padStart(2, '0') + '<span>/</span>' + slidesCount);
    //             };

    //             slider.on('init', function (event, slick) {
    //                 count.append(sliderCounter);
    //                 updateSliderCounter(slick);
    //             });

    //             slider.on('afterChange', function (event, slick, currentSlide) {
    //                 updateSliderCounter(slick, currentSlide);
    //             });

    //             slider.slick({
    //                 slidesToShow: 1,
    //                 slidesToScroll: 1,
    //                 arrows: true,
    //                 prevArrow: $slick_prev,
    //                 nextArrow: $slick_next,
    //                 appendArrows: arrows,
    //                 dots: true,
    //                 appendDots: dots,
    //                 autoplay: false,
    //                 autoplaySpeed: 3000,
    //                 speed: 800,
    //                 infinite: true,
    //             });
    //         }
    //     });
    // });

    jQuery(".testimonials").each(function (index) {

        // $slick_prev = '<button type="button" class="slick-prev hidden"><svg width="10" height="16" viewBox="0 0 10 16" fill="none" xmlns="http://www.w3.org/2000/svg"><title>Previous Arrow</title><path d="M8.26758 2L2.01642 8.25116L8.25788 14.4926" stroke="#146EF5" stroke-width="3" stroke-linecap="round" stroke-linejoin="round"/></svg></button>';
        // $slick_next = '<button type="button" class="slick-next"><svg width="10" height="16" viewBox="0 0 10 16" fill="none" xmlns="http://www.w3.org/2000/svg"><title>Next Arrow</title><path d="M1.75 2L8.00116 8.25116L1.7597 14.4926" stroke="#146EF5" stroke-width="3" stroke-linecap="round" stroke-linejoin="round"/></svg></button>';
        let slider = jQuery(this).find('.testimonials_wrapper_main_inner_list');
        let slide = jQuery(slider).find('.testimonials_wrapper_main_inner_list_item');
        let sliderCounter = jQuery(slide).find('.testimonials_wrapper_main_inner_nav .testimonials_wrapper_main_inner_nav_count');
        let sliderNav = jQuery(this).find('.testimonials_wrapper_main_inner_list_nav');
        // let count = jQuery(slide).find('.testimonials_wrapper_main_inner_nav');
        // let dots = jQuery(slide).find('.testimonials_wrapper_main_inner_nav .testimonials_wrapper_main_inner_nav_dots');
        // let arrows = jQuery(slide).find('.testimonials_wrapper_main_inner_nav .testimonials_wrapper_main_inner_nav_arrows');

        if (jQuery(slide).length > 1) {
            var currentSlide;
            var slidesCount;

            var updateSliderCounter = function (slick, currentIndex) {
                currentSlide = slick.slickCurrentSlide() + 1;
                slidesCount = slick.slideCount.toString().padStart(2, '0');
                $(sliderCounter).html(currentSlide.toString().padStart(2, '0') + '<span>/</span>' + slidesCount);
            };

            slider.on('init', function (event, slick) {
                // count.append(sliderCounter);
                updateSliderCounter(slick);
            });

            slider.on('afterChange', function (event, slick, currentSlide) {
                updateSliderCounter(slick, currentSlide);
            });

            $(slider).on('init beforeChange afterChange', function (event, slick, currentSlide, nextSlide) {
                var dotHtml = $(slider).find('> ul.slick-dots').clone();
                $(slider).find('.slick-current .testimonials_wrapper_main_inner_nav_dots').html(dotHtml);
            });

            $('body').on("click", '.testimonials_wrapper_main_inner_list .testimonials_wrapper_main_inner_list_item .slick-dots button', function (e) {
                e.preventDefault();
                var slideno = $(this).text();
                var slideParent = $(this).closest(".testimonials_wrapper_main_inner_list");
                $(slideParent).slick('slickGoTo', slideno - 1);
            });

            slider.slick({
                slidesToShow: 1,
                slidesToScroll: 1,
                arrows: true,
                dots: true,
                autoplay: false,
                autoplaySpeed: 3000,
                speed: 800,
                infinite: true,
                asNavFor: sliderNav
            }).on('beforeChange', function (event, slick, currentSlide, nextSlide) {
                $(slider).find('.current').text(nextSlide + 1);
            });

            sliderNav.slick({
                slidesToShow: 1,
                slidesToScroll: 1,
                asNavFor: slider,
                dots: true,
                arrows: false,
                focusOnSelect: true
            });

            var prevSLider = jQuery(slider).find('.slick-prev-custom');
            var prevSLiderDefault = jQuery(slider).find('button.slick-prev.slick-arrow');

            $(prevSLider).click(function () {
                $(prevSLiderDefault).trigger("click");
            });

            var nextSLider = jQuery(slider).find('.slick-next-custom');
            var nextSLiderDefault = jQuery(slider).find('button.slick-next.slick-arrow');

            $(nextSLider).click(function () {
                $(nextSLiderDefault).trigger("click");
            });
        }
    });

    jQuery(".testimonials ul.slick-dots").each(function (index) {
        if (jQuery(this).find('li').length == 1) {
            jQuery(this).remove();
        }
    });


    jQuery(".image_content_with_accordion_sec").each(function (index) {
        jQuery(this).find(".accordion_list__item .title_sec").on("click", function (e) {
            e.preventDefault();
            var $this = $(this).parent().parent();
            if ($this.siblings().hasClass("active")) {
                $(".accordion_content").slideUp(400);
                $(".accordion_list__item").removeClass("active");
            }
            $(this).parent().parent().toggleClass("active");
            $(this).parent().parent().find('.accordion_content').slideToggle(400);
        });
    });

    jQuery(document).on("click", ".footer_column .footer_column_heading", function (e) {
        if (jQuery(window).width() < 991) {
            e.preventDefault();
            if (jQuery(this).next().is(":hidden")) {
                jQuery(".footer_menu_list").slideUp(400);
                jQuery(".footer_column").removeClass("active");
                jQuery(this).parent(".footer_column").addClass("active");
                jQuery(this).next().slideDown();
            } else {
                jQuery(".footer_column").removeClass("active");
                jQuery(this).next().slideUp();
            }
        }
    });

    jQuery(".hero_banner_sec").each(function (index) {
        let slide = jQuery(this).find('.images_list__item');
        let slider = jQuery(this).find('.images_list');
        // let dots = jQuery(this).find('.slider_dots');
        if (jQuery(slide).length > 0) {
            jQuery(slider).slick({
                slidesToShow: 1,
                slidesToScroll: 1,
                arrows: false,
                dots: false,
                autoplay: true,
                autoplaySpeed: 3000,
                rtl: false,
                fade: true,
                speed: 1200,
                infinite: true,
            });
        }
    });

    jQuery(".customers_logo_sec").each(function (index) {
        let slide = jQuery(this).find('.logo_list__item');
        let slider = jQuery(this).find('.logo_list.slider_view');
        // let dots = jQuery(this).find('.slider_dots');
        if (jQuery(slide).length > 1) {
            jQuery(slider).slick({
                slidesToShow: 7,
                slidesToScroll: 1,
                infinite: true,
                arrows: false,
                dots: false,
                autoplay: true,
                autoplaySpeed: 1500,
                rtl: false,
                responsive: [{
                        breakpoint: 1441,
                        settings: {
                            slidesToShow: 5,
                        }
                    },
                    {
                        breakpoint: 1200,
                        settings: {
                            slidesToShow: 4,
                        }
                    },
                    {
                        breakpoint: 992,
                        settings: {
                            slidesToShow: 3,
                        }
                    },
                    {
                        breakpoint: 768,
                        settings: {
                            slidesToShow: 2,
                        }
                    },
                    {
                        breakpoint: 576,
                        settings: {
                            slidesToShow: 1,
                        }
                    },
                ]
            });
        }
    });

    equalheight('.four_columns_content_sec__inner .title');

    offsetLeft();

    jQuery(".post_single_content_sec").each(function () {
        var textString = jQuery(this).find(".post_single_content_sec_content_list *:not(:has(*)):visible").text();
        if (textString != "" && textString != undefined && textString != null) {
            var textWord = textString.trim().split(/\s+/).length;
            var minReadCount = textWord / 60;
            minReadCount = Math.round(minReadCount);
            minReadCount = parseInt(minReadCount);
            // jQuery(this).find(".post_single_content_sec_default_content .read_time_text").text(minReadCount + " min read");
            jQuery(this).find(".post_single_content_sec_default_content .read_time_text:not(.custom_read_more_text)").text(minReadCount + " min read");
            jQuery(this).find(".post_single_content_sec_default_content .read_time").addClass("show");
        }
    })

    var locHash = window.location.hash;
    if (locHash != undefined && locHash != "" && locHash != null) {
        if (jQuery(locHash + "_scroll").length > 0) {
            jQuery("body, html").animate({
                scrollTop: jQuery(locHash + "_scroll").offset().top - (jQuery(".site-header").outerHeight() + 40)
            }, 1000);
        }
    }
    jQuery("a[href*='#']:not(.tabbing_link)").on("click", function (e) {
        e.preventDefault();
        var link1 = jQuery(this).attr("href");
        var target1 = jQuery(this).attr("target");
        if (target1 == undefined || target1 == null || target1 == "") {
            target1 = "_self";
        }
        if (link1.indexOf("#") > -1) {
            var link1Arr = link1.split('#');
            if (link1Arr.length > 1) {
                var linkId = link1Arr[1];
                if (jQuery("#" + linkId + "_scroll").length > 0) {
                    jQuery("body, html").animate({
                        scrollTop: jQuery("#" + linkId + "_scroll").offset().top - (jQuery(".site-header").outerHeight() + 40)
                    }, 1000);
                } else {
                    window.open(link1, target1);
                }
            } else {
                window.open(link1, target1);
            }
        } else {
            window.open(link1, target1);
        }
    })

    jQuery("a[href*='#'].tabbing_link").on("click", function (e) {
        e.preventDefault();
        var link1 = jQuery(this).attr("href");
        var target1 = jQuery(this).attr("target");
        if (target1 == undefined || target1 == null || target1 == "") {
            target1 = "_self";
        }
        if (link1.indexOf("#") > -1) {
            var link1Arr = link1.split('#');
            if (link1Arr.length > 1) {
                var linkId = link1Arr[1];
                jQuery('.post_single_content_sec_content_list_item').hide();
                jQuery("#" + linkId + "_scroll").show();
            } else {
                jQuery('.content_list_inner').find('.post_single_content_sec_content_list_item').hide();
                window.open(link1, target1);
            }
        } else {
            window.open(link1, target1);
        }

        if ($('.content_with_sidebar .content_list .content_list_inner').length > 0) {
            $('html, body').animate({
                scrollTop: $('.content_with_sidebar .content_list .content_list_inner').offset().top - 200
            }, 'slow');
        }


    })

    if (jQuery(".chart_clickable").length > 0) {
        jQuery(".chart_clickable").on("click", function () {
            var itemId = jQuery(this).attr("data-id");
            if (jQuery(this).hasClass("have_link") && itemId != "" && itemId != undefined && itemId != null && itemId.indexOf("http") > -1) {
                window.open(itemId, "_self");
            } else {
                if (itemId != "" && itemId != undefined && itemId != null) {
                    if (jQuery(".commercial_solutions_list_sec_filter_list .filter_btn[data-click='" + itemId + "']").length > 0) {
                        jQuery(".commercial_solutions_list_sec_filter_list .filter_btn[data-click='" + itemId + "']").click();
                        jQuery("body, html").animate({
                            scrollTop: jQuery(".commercial_solutions_list_sec").offset().top - (jQuery("header.site-header").outerHeight() + 20)
                        }, 1000);
                    }
                }
            }
        })
    }

    if (jQuery(".tab_data_wrapper_list .tab_content_item .tab_content_inner_data_nav_arrows .slick-next").length > 0) {
        jQuery(".tab_data_wrapper_list .tab_content_item .tab_content_inner_data_nav_arrows .slick-next").on("click", function () {
            if (jQuery(this).closest(".tab_data_wrapper_list").find(".tabs .tab.active").length > 0) {
                var activeIndex = jQuery(this).closest(".tab_data_wrapper_list").find(".tabs .tab.active").index();
                var totalTabs = jQuery(this).closest(".tab_data_wrapper_list").find(".tabs .tab").length;
                if ((activeIndex + 1) == totalTabs) {
                    return false;
                } else {
                    jQuery(this).closest(".tab_data_wrapper_list").find(".tabs .tab").removeClass("active");
                    if (jQuery(this).closest(".tab_data_wrapper_list").find(".tabs .tab:nth-child(" + (activeIndex + 2) + ")").length > 0) {
                        jQuery(this).closest(".tab_data_wrapper_list").find(".tabs .tab:nth-child(" + (activeIndex + 2) + ")").click();
                    }
                }
            }
        })
    }
    if (jQuery(".tab_data_wrapper_list .tab_content_item .tab_content_inner_data_nav_arrows .slick-prev").length > 0) {
        jQuery(".tab_data_wrapper_list .tab_content_item .tab_content_inner_data_nav_arrows .slick-prev").on("click", function () {
            if (jQuery(this).closest(".tab_data_wrapper_list").find(".tabs .tab.active").length > 0) {
                var activeIndex = jQuery(this).closest(".tab_data_wrapper_list").find(".tabs .tab.active").index();
                var totalTabs = jQuery(this).closest(".tab_data_wrapper_list").find(".tabs .tab").length;
                if ((activeIndex) > 0) {
                    jQuery(this).closest(".tab_data_wrapper_list").find(".tabs .tab").removeClass("active");
                    if (jQuery(this).closest(".tab_data_wrapper_list").find(".tabs .tab:nth-child(" + (activeIndex) + ")").length > 0) {
                        jQuery(this).closest(".tab_data_wrapper_list").find(".tabs .tab:nth-child(" + (activeIndex) + ")").click();
                    }
                }
            }
        })
    }

    var selectInterval = setInterval(function () {
        if (document.readyState == "complete") {
            clearInterval(selectInterval);
            jQuery('.hs-fieldtype-select select').selectric({
                openOnFocus: false,
                disableOnMobile: false,
                nativeOnMobile: false
            });
        }
    })
});

jQuery(window).resize(function ($) {
    if (jQuery('.four_columns_content_sec__inner .title').length > 0) {
        equalheight('.four_columns_content_sec__inner .title');
    }
    // if (jQuery(window).width() > 1199) {
    //     jQuery(".left_sidebar .left_sidebar_menu .menu-item.menu-item-has-children .sub-menu").css('display', 'block');
    //     jQuery(".left_sidebar .left_sidebar_menu .menu-item.menu-item-has-children").addClass('open');
    //     jQuery(".left_sidebar .left_sidebar_menu .menu-item.menu-item-has-children a.tabbing_link").addClass('active');
    // } else {
    //     jQuery(".left_sidebar .left_sidebar_menu .menu-item.menu-item-has-children .sub-menu").css('display', 'none');
    //     jQuery(".left_sidebar .left_sidebar_menu .menu-item.menu-item-has-children").removeClass('open');
    //     jQuery(".left_sidebar .left_sidebar_menu .menu-item.menu-item-has-children a.tabbing_link").removeClass('active');
    // };
    offsetLeft();
});

function offsetLeft() {
    if (jQuery(window).width() < 1200) {
        if ((jQuery('.tab_data_wrapper_list .tabs').length > 0)) {
            var taboffset = jQuery('.tab_data_wrapper_list .tabs').offset(),
                tabwindWidth = jQuery(window).width();
            jQuery('.tab_data_wrapper_list .tabs').css('width', (tabwindWidth - taboffset.left));
        }
    } else {
        jQuery('.tab_data_wrapper_list .tabs').removeAttr("style");
    }

    if (jQuery(window).width() < 992) {
        if ((jQuery('.most_recent_post_sec_inner_filter_inner').length > 0)) {
            var taboffset = jQuery('.most_recent_post_sec_inner_filter_inner').offset(),
                tabwindWidth = jQuery(window).width();
            jQuery('.most_recent_post_sec_inner_filter_inner').css('width', (tabwindWidth - taboffset.left));
        }
    } else {
        jQuery('.most_recent_post_sec_inner_filter_inner').removeAttr("style");
    }
}

function equalheight(container) {

    var currentTallest = 0,
        currentRowStart = 0,
        rowDivs = new Array(),
        $el,
        topPosition = 0;
    jQuery(container).each(function () {

        $el = jQuery(this);
        jQuery($el).height('auto')
        topPostion = $el.position().top;

        if (currentRowStart != topPostion) {
            for (currentDiv = 0; currentDiv < rowDivs.length; currentDiv++) {
                rowDivs[currentDiv].height(currentTallest);
            }
            rowDivs.length = 0; // empty the array
            currentRowStart = topPostion;
            currentTallest = $el.height();
            rowDivs.push($el);
        } else {
            rowDivs.push($el);
            currentTallest = (currentTallest < $el.height()) ? ($el.height()) : (currentTallest);
        }
        for (currentDiv = 0; currentDiv < rowDivs.length; currentDiv++) {
            rowDivs[currentDiv].height(currentTallest);
        }
    });
}